// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString.jsx';

type Props = {
  extendedDataset?: boolean,
  template: string,
  values: {
    arrivalDate: string,
    departureDate: string,
  },
};

export const DateSummary = ({ extendedDataset = false, template, values }: Props) => {
  return (
    <div
      className={classnames('PackagePriceSummary-section', {
        'PackagePriceSummary-section--extended': extendedDataset,
      })}
    >
      <Icon
        color={COLORS.BLUE}
        name={ICONS.DATE}
        className="PackagePriceSummary-icon"
        width="1.875rem"
        hasRtl
      />
      <TemplateString
        template={template}
        // $FlowFixMe
        values={values}
        valuesClassName={{
          arrivalDate: 'PackagePriceSummary-arrivalDate',
          departureDate: 'PackagePriceSummary-departureDate',
        }}
      />
    </div>
  );
};
